export default __webpack_public_path__ + "static/allrings-c2ae7ee42cdb411ed46ceb4301c1639e.png";